import React from 'react';
import { Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <Box 
      component="footer" 
      sx={{ 
        textAlign: 'center', 
        padding: 2, 
        marginTop: 'auto', 
        backgroundColor: '#f5f5f5' 
      }}
    >
      <Typography variant="body2" color="textSecondary">
        © {new Date().getFullYear()} GestionCantine. Tous droits réservés. 
        <Link to="/privacy-policy" style={{ marginLeft: 8 }}>Politique de confidentialité</Link>
      </Typography>
    </Box>
  );
};

export default Footer;
